import { render, staticRenderFns } from "./SuperAdminDashboardView.vue?vue&type=template&id=fce38eb8&scoped=true&"
import script from "./SuperAdminDashboardView.vue?vue&type=script&lang=js&"
export * from "./SuperAdminDashboardView.vue?vue&type=script&lang=js&"
import style0 from "./SuperAdminDashboardView.vue?vue&type=style&index=0&id=fce38eb8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fce38eb8",
  null
  
)

export default component.exports